import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { PatientCountAction } from "../../../../sagas/saga-actions";
import { revokePatientByUser } from "../../../../sagas/saga-revoke";
import { sendUploadLinkByUserSagaAction } from "../../../../sagas/saga-uploadLink";
import { sendDocumentSignLinkSagaAction } from "../../../../sagas/saga-docSignLink";
import { downloadSignedDocSagaAction } from "../../../../sagas/saga-docSignDownload";

import ConfirmPopup from "../../../../components/confirmPopup";
import CustomButton from "../../../../components/customButton";
import TransferPopup from "../../../transferPopup";
import { secureMsgIcon } from "../../../../assets/svg";
import { formatPhoneWithCountryCode } from "../../../../utilities/helpers";
import "./styles.scss";

const UserHeader = (props) => {
  const [state, setState] = useState({
    patientDocSignStatus: {},
    releasePopup: false,
    transferPopup: false,
  });

  const updateDocSignStatus = (data) => {
    let patientId = data.patientId;
    if (data.patientId) {
      delete data.patientId;
      let patientDocSignStatus = state.patientDocSignStatus;
      patientDocSignStatus[patientId] = data;
      setState((st) => ({ ...st, patientDocSignStatus }));
    }
  };

  const revokePatient = () => {
    const { user, patients } = props;
    const object = {
      userId: user.id,
      patientId: patients.patient.id,
    };
    props.revokePatientByUser(object, () => {
      props.PatientCount();
      const event = new CustomEvent("revokeUser");
      window.dispatchEvent(event);
    });
    setState((st) => ({ ...st, releasePopup: false }));
  };

  useEffect(() => {
    // declaring local to be used in the event handler
    let _updateDocSignStatus = (data) => {
      updateDocSignStatus(data);
    };

    // socket event listener for socket service
    window.addEventListener(
      "updateDocSignLinkStatus",
      (e) => {
        let { msg } = e.detail;
        _updateDocSignStatus(msg);
      },
      false
    );
  }, []);

  const handleCancel = () => {
    setState((st) => ({ ...st, transferPopup: false }));
  };
  const tabSet = localStorage.getItem("tabSet");
  const { patients, isNewPatient } = props;

  return (
    <>
      {state.releasePopup && (
        <ConfirmPopup
          titleMessage="Confirm to Release"
          handleCancel={() =>
            setState((st) => ({ ...st, releasePopup: false }))
          }
          handleDelete={revokePatient}
          isVisible={state.releasePopup}
          submitButtonText="Release"
          cancelButtonText="Cancel"
          message="Are you sure you want to release this patient?"
        />
      )}

      {state.transferPopup && (
        <TransferPopup
          handleCancel={handleCancel}
          handleChat={props.handleChat}
        />
      )}
      {isNewPatient &&
        isNewPatient.cellPhone && (
          <div className="chat-header-wrapper">
            <div className="current-user-name">
              <a
                title={
                  patients.patient.firstName || patients.patient?.lastName
                    ? `${patients.patient.firstName} ${patients.patient
                        .lastName || ""}`
                    : formatPhoneWithCountryCode(
                        patients.patient.cellPhone,
                        patients.patient.countryCode
                      )
                }
                className="user-name"
              >
                {patients.patient.firstName || patients.patient.lastName
                  ? `${patients.patient.firstName} ${patients.patient
                      .lastName || ""}`
                  : formatPhoneWithCountryCode(
                      patients.patient.cellPhone,
                      patients.patient.countryCode
                    )}
                <p className="chat-cell-Number">
                  {formatPhoneWithCountryCode(
                    patients?.patient?.cellPhone,
                    patients?.patient?.countryCode
                  )}
                </p>
              </a>

              {props.secureSessionIsActive && (
                <div className="secure-session">
                  <button className="secure-session-btn">
                    {secureMsgIcon}
                    Secure Session
                  </button>
                </div>
              )}
            </div>

            {tabSet &&
            tabSet === "activeItem" &&
            !props.secureSessionIsActive ? (
              <>
                <div className="header-buttons">
                  <CustomButton
                    btntype="clear"
                    title="Transfer Number"
                    onClick={() =>
                      setState((st) => ({ ...st, transferPopup: true }))
                    }
                  />

                  <CustomButton
                    btntype="clear"
                    title="Release Number"
                    onClick={() =>
                      setState((st) => ({ ...st, releasePopup: true }))
                    }
                  />
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    patients: state.patients,
    isNewPatient: state.patients.patient,
    user: state.login.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendUploadLinkToPatient: bindActionCreators(
      sendUploadLinkByUserSagaAction,
      dispatch
    ),
    sendDocSignLinkToPatient: bindActionCreators(
      sendDocumentSignLinkSagaAction,
      dispatch
    ),
    revokePatientByUser: bindActionCreators(revokePatientByUser, dispatch),
    PatientCount: bindActionCreators(PatientCountAction, dispatch),
    downloadSignedDocument: bindActionCreators(
      downloadSignedDocSagaAction,
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserHeader);
